import React from 'react';
import { motion } from 'framer-motion';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export const CTAButton = ({
  children,
  onClick,
  className = ''
}: CTAButtonProps) => {
  const handleClick = (e: React.MouseEvent) => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'El Código del Visto',
        content_type: 'product',
        value: 87,
        currency: 'MXN'
      });
    }
    onClick?.();
  };
  return <motion.a href="#offer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
    handleClick();
  }} className={`
        inline-block text-center
        bg-brand-red hover:bg-brand-redHover text-white 
        font-display text-xl md:text-3xl tracking-wider 
        py-3 px-6 md:py-4 md:px-8 rounded-none uppercase transition-colors
        shadow-glow-red hover:shadow-glow-red-strong
        border border-brand-red/50
        ${className}
      `} data-id="element-9">
      {children}
    </motion.a>;
};